import { Weld } from '@bechtel/types';

export interface WeldTagItemProps {
  showDelete?: boolean;
  item: Weld;
  onDelete?: (weldId: string) => void;
}

export interface WeldTagSelectorProps {
  items: Weld[];
  fieldName: string;
  onSearch: (searchQuery: string) => void;
  loading: boolean;
}
